module.exports = __webpack_public_path__ + "img/message-round.85ecd780.svg";